module.exports = __webpack_public_path__ + "img/swords-gray.42e47c58.svg";